<template>
    <v-card class="ma-2">
        <v-card-text>
            <v-row>
            <v-col cols="3" class="d-flex justify-start flex-grow-0 flex-shrink-1">
                <v-img
                :src="loadImg"
                @error="loadDefaultImg">
                </v-img>
            </v-col>
            <v-col cols="6" class="flex-grow-1 flex-shrink-0" >
                <p>{{ product.title }}</p>
                <p>R$ {{ product.price }}</p>
            </v-col>
            <v-col cols="3" class="d-flex justify-end flex-grow-0 flex-shrink-0">
            <v-btn  @click="removeFromCart(product.id)" text color="error">
                Remover
            </v-btn>
            </v-col>
            </v-row>
        </v-card-text>
        <br/>
    </v-card>
</template>

<script>

import Api from '../../services/Api';
import {REMOVE_FROM_CART} from '../../store/actions/store.js';

export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        removeFromCart(id){
            this.$store.dispatch(REMOVE_FROM_CART, {id});
        },        
        loadDefaultImg(){
            this.showDefaultImg = true;
        }
    },
    computed:{        
        loadImg: function(){
            return (this.product.media == undefined ? 
                "https://cdn.vuetifyjs.com/images/cards/store.jpg" : 
                Api.getBaseUrl()+"imagens/"+this.product.media.name);
        }
    }
}
</script>
